import React from 'react'
import styled from 'styled-components'
import { themeEstra } from 'src/styles/themeEstra'
import { Container } from 'app/components/ui/Container'
import logo from 'static/images/estra_logo.svg'
import { routes } from 'app/routes'
import { Link } from 'react-router-dom'
import { Flex } from 'app/components/ui/Flex'
import { TopMenuDropdown } from '../TopMenuDropdown'

export const TopMenu: React.FC = () => {
  return (
    <Wrapper>
      <TopMenuWrapper>
        <Container>
          <Navbar justifyContent='space-between'>
            <Brand to={routes.login.makeUrl()}>
              {' '}
              <img src={logo} alt='estra'></img>
            </Brand>
            <TopMenuDropdown></TopMenuDropdown>
          </Navbar>
        </Container>
      </TopMenuWrapper>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  position: relative;
  z-index: 5;
`

const TopMenuWrapper = styled.div`
  padding: 0.5rem 0 2.5rem;
  @media (min-width: ${themeEstra.bp.tablet}) {
    padding: 2.5rem 0;
  }
`

const Navbar = styled(Flex)``

const Brand = styled(Link)`
  padding: 1rem 0;
  display: block;
  img {
    height: 24px;
    width: auto;
  }
  @media (min-width: ${themeEstra.bp.tablet}) {
    padding: 0;
    img {
      height: 38px;
    }
  }
  @media (min-width: 1000px) {
    img {
      height: 43px;
    }
  }
`
